import { render, staticRenderFns } from "./BirthdaysOfMonth.vue?vue&type=template&id=3b0d674a&scoped=true"
import script from "./BirthdaysOfMonth.vue?vue&type=script&lang=js"
export * from "./BirthdaysOfMonth.vue?vue&type=script&lang=js"
import style0 from "./BirthdaysOfMonth.vue?vue&type=style&index=0&id=3b0d674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d674a",
  null
  
)

export default component.exports